export default {
  hint: "Агрегированная статистика каталога (стартовый дашборд).",
  relation: "Связи",
  total: "Всего записей",
  updated: "Обновлено {{date}}",
  countsTitle: "Сущности каталога",
  byYear: "Издания по годам",
  topPublishers: "Издательства",
  topSubjects: "Тематики",
  topPrizes: "Премии",
  empty: "Статистика пока не собрана.",
}
